import React from "react";

import Header from "./Header";
import Home from "./Home/Home";
import Footer from "./Footer/Footer";
import ErrorBoundary from "./ErrorBoundary";

// Single-page landing only. All content lives in Home component (scroll from top to bottom).
export default function Container() {
  return (
    <div className="App d-flex flex-column">
      <ErrorBoundary>
        <Header />
        <Home />
        <Footer />
      </ErrorBoundary>
    </div>
  );
}
